var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Box, Grid, Icon, Paper, } from '@material-ui/core';
import { Button, Container, useDialogs, LoadingBounce, } from '@michelin/acid-components';
import CloseIcon from '@material-ui/icons/Close';
import './LegalConsent.css';
import { useTranslation } from 'react-i18next';
import { API_GATEWAY } from '../../helpers/api';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import Oauth from '../../providers/Auth0Provider/Auth0Provider';
import { usePushNotification } from '../../hooks/APICallsHooks/usePushNotification';
import { useAcceptLegalTerms } from '../../hooks/APICallsHooks/useAcceptLegalTerms';
import { loggerError, logger } from '../../helpers/Log';
import LegalConsentContent from './LegalConsentContent';
import { TERMS_OF_USE, TERMS_OF_SERVICE, PRIVACY_POLICY, TERMS_ACCEPTED_KEY, } from '../../constants/constants';
import { removeCookie } from '../../helpers/utils';
import { useEnqueueSnackbar } from '../../hooks/useEnqueueSnackbar';
import { Logo } from '../Logo/Logo';
import { useGetAccessToken } from '../../hooks/useGetAccessToken';
import { LEGAL_DOCUMENTS } from '../../constants/legalDocuments';
var ERROR_MESSAGE = 'An error has occurred, please try again or contact the administrator';
var LegalConsent = function (_a) {
    var updatedDocuments = _a.updatedDocuments;
    var t = useTranslation().t;
    var dialogs = useDialogs();
    var _b = useContext(CentralProviderContext), currentLanguage = _b.currentLanguage, setShowLegalConsent = _b.setShowLegalConsent, centralProfile = _b.centralProfile;
    var accessToken = useGetAccessToken();
    var sendLegalDocuments = usePushNotification(false);
    var acceptLegalTerms = useAcceptLegalTerms();
    var snackbar = useEnqueueSnackbar();
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var language = currentLanguage || 'en_US';
    var closeReviewPanel = function () {
        dialogs.confirmDialog(t('You must accept the legal terms to use this application'), t('Warning'), t('Review Terms'), t('Logout'), function () { }, function () { return Oauth.logout(); });
    };
    var acceptTerms = function () {
        setLoading(true);
        acceptLegalTerms.call().then(function (response) {
            var _a;
            setLoading(false);
            if (response.error) {
                loggerError('error accepting terms', response.error);
                snackbar.enqueueMessages(t(ERROR_MESSAGE), 'error');
            }
            else {
                logger('terms accepted', (_a = response.data) === null || _a === void 0 ? void 0 : _a.result);
                snackbar.enqueueMessages(t('You have agreed to accept the Terms of Use, Terms of Service and Privacy Notice'), 'success');
                removeCookie(TERMS_ACCEPTED_KEY);
            }
            setShowLegalConsent(false);
        });
    };
    var sendEmail = function () {
        setLoading(true);
        var httpHeaders = {
            httpHeaders: {
                authorization: "Bearer ".concat(accessToken),
                Accept: 'application/pdf',
            },
        };
        var isUpdatedDocuments = updatedDocuments.length > 0;
        var templateId = isUpdatedDocuments ? 'custom_legal_terms_updated' : 'custom_legal_terms';
        var termsOfUseUpdated;
        var termsOfServiceUpdated;
        var privacyPolicyUpdated;
        var attachmentNames = '';
        if (isUpdatedDocuments) {
            var attachmentNamesArray_1 = [];
            if (updatedDocuments.includes(TERMS_OF_USE)) {
                termsOfUseUpdated = true;
                attachmentNamesArray_1 = __spreadArray(__spreadArray([], __read(attachmentNamesArray_1), false), [t(LEGAL_DOCUMENTS.termsOfUse.pdf_title)], false);
            }
            if (updatedDocuments.includes(TERMS_OF_SERVICE)) {
                termsOfServiceUpdated = true;
                attachmentNamesArray_1 = __spreadArray(__spreadArray([], __read(attachmentNamesArray_1), false), [t(LEGAL_DOCUMENTS.termsOfService.pdf_title)], false);
            }
            if (updatedDocuments.includes(PRIVACY_POLICY)) {
                privacyPolicyUpdated = true;
                attachmentNamesArray_1 = __spreadArray(__spreadArray([], __read(attachmentNamesArray_1), false), [t(LEGAL_DOCUMENTS.privacyPolicy.pdf_title)], false);
            }
            attachmentNames = attachmentNamesArray_1.reduce(function (prevVal, currVal, idx) { return (idx === 0 ? currVal : idx === attachmentNamesArray_1.length - 1 && attachmentNamesArray_1.length > 1 ? "".concat(prevVal, " and ").concat(currVal) : "".concat(prevVal, ", ").concat(currVal)); }, attachmentNames);
            attachmentNames = "".concat(attachmentNames, ".");
        }
        var termsOfUseRequest = {
            url: "".concat(API_GATEWAY, "/central/legaldocuments?file=").concat(LEGAL_DOCUMENTS.termsOfUse.pdf_key, "&lang=").concat(language),
            metadata: httpHeaders,
        };
        var termsOfServiceRequest = {
            url: "".concat(API_GATEWAY, "/central/legaldocuments?file=").concat(LEGAL_DOCUMENTS.termsOfService.pdf_key, "&lang=").concat(language),
            metadata: httpHeaders,
        };
        var privacyPolicyRequest = {
            url: "".concat(API_GATEWAY, "/central/legaldocuments?file=").concat(LEGAL_DOCUMENTS.privacyPolicy.pdf_key, "&lang=").concat(language),
            metadata: httpHeaders,
        };
        var attachments = isUpdatedDocuments
            ? __spreadArray(__spreadArray(__spreadArray([], __read((termsOfUseUpdated ? [termsOfUseRequest] : [])), false), __read((termsOfServiceUpdated ? [termsOfServiceRequest] : [])), false), __read((privacyPolicyUpdated ? [privacyPolicyRequest] : [])), false) : [
            privacyPolicyRequest,
            termsOfUseRequest,
            termsOfServiceRequest,
        ];
        var legalNotificationPayload = {
            template_id: templateId,
            notifiable_id: '1',
            notifiable_type: 'order',
            inAppOnly: false,
            emailOnly: true,
            user_id: centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.uid,
            attachments: attachments,
            content: {
                attachments: attachmentNames,
            },
        };
        sendLegalDocuments.call(legalNotificationPayload).then(function (response) {
            setLoading(false);
            if (response.error) {
                loggerError('error sending terms email', response.error);
                snackbar.enqueueMessages(t(ERROR_MESSAGE), 'error');
            }
            else {
                logger('terms email sent succesfully', response.data);
                snackbar.enqueueMessages(t('The email was successfully sent'), 'success');
            }
        });
    };
    return (React.createElement("div", { className: "main-wrapper1" },
        loading
            && (React.createElement("div", { className: "loading-bounce-container" },
                React.createElement(LoadingBounce, { style: { height: '100vh' } }))),
        React.createElement("main", { className: "ulp-outer1 ".concat(loading ? 'loading-container' : '') },
            React.createElement(Grid, { className: "ulp-box1", container: true, spacing: 0, direction: "column", alignItems: "center", justify: "center" },
                React.createElement(CssBaseline, null),
                React.createElement(Paper, null,
                    React.createElement(Container, null,
                        React.createElement("section", { className: "ulp-box1" },
                            React.createElement(Container, { spacing: 3 },
                                React.createElement("main", null,
                                    React.createElement("section", { className: "ulp-box1" },
                                        React.createElement(Grid, { container: true },
                                            React.createElement(CloseIcon, { className: "closeIcon1", onClick: closeReviewPanel }),
                                            React.createElement(Grid, { className: "ulp-header1 _header" },
                                                React.createElement(Grid, { className: "michelin-logo" },
                                                    React.createElement(Logo, { darkMode: false, logoType: "michelin" })),
                                                React.createElement(Grid, null,
                                                    React.createElement("h1", { className: "header-title1" }, t('Michelin Legal Terms'))),
                                                React.createElement(LegalConsentContent, { updatedDocuments: updatedDocuments, setLoading: setLoading }),
                                                React.createElement(Box, { display: "flex", alignItems: "center" },
                                                    React.createElement(Icon, { color: "primary" }, "email"),
                                                    React.createElement("div", { style: { cursor: 'pointer', paddingLeft: '0.5rem' } },
                                                        React.createElement("span", { className: "text-simple1 margin-0", onClick: sendEmail }, t('Send to my email'))))))))))),
                    React.createElement(Grid, { className: "button-bar1" },
                        React.createElement(Button, { variant: "contained", color: "primary", onClick: acceptTerms }, t('Accept'))))))));
};
export default LegalConsent;
//# sourceMappingURL=LegalConsent.js.map